"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hubUsersEpic = void 0;

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _hubUsersActions = require("../actions/hubUsersActions");

var _hubUsersApi = require("../api/hubUsersApi");

var hubUsersEpic = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _hubUsersApi.getUsers,
  initiatingActionType: _hubUsersActions.actionTypes.LOAD,
  requestStatusSelector: (0, _getRequestStatus.default)(_hubUsersActions.actionTypes.FETCH),
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _hubUsersActions.requestActions
}));
exports.hubUsersEpic = hubUsersEpic;